module.exports = __webpack_public_path__ + "media/images/careers/desk-6786344d8d1f41783521c9d212d70def.svg";